"use strict";
/*
 * Copyright 2018 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MosaicInfo = void 0;

var catbuffer_typescript_1 = require("catbuffer-typescript");
/**
 * The mosaic info structure describes a mosaic.
 */


var MosaicInfo = /*#__PURE__*/function () {
  /**
   * @param version
   * @param recordId
   * @param id
   * @param supply
   * @param startHeight
   * @param ownerAddress
   * @param revision
   * @param flags
   * @param divisibility
   * @param duration
   */
  function MosaicInfo(
  /**
   * Version
   */
  version,
  /**
   * The database record id.
   */
  recordId,
  /**
   * The mosaic id.
   */
  id,
  /**
   * The mosaic supply.
   */
  supply,
  /**
   * The block height were mosaic was created.
   */
  startHeight,
  /**
   * The mosaic owner address.
   */
  ownerAddress,
  /**
   * The mosaic revision
   */
  revision,
  /**
   * The mosaic flags.
   */
  flags,
  /**
   * Mosaic divisibility
   */
  divisibility,
  /**
   * Mosaic duration
   */
  duration) {
    _classCallCheck(this, MosaicInfo);

    this.version = version;
    this.recordId = recordId;
    this.id = id;
    this.supply = supply;
    this.startHeight = startHeight;
    this.ownerAddress = ownerAddress;
    this.revision = revision;
    this.flags = flags;
    this.divisibility = divisibility;
    this.duration = duration;
  }
  /**
   * Is mosaic supply mutable
   * @returns {boolean}
   */


  _createClass(MosaicInfo, [{
    key: "isSupplyMutable",
    value: function isSupplyMutable() {
      return this.flags.supplyMutable;
    }
    /**
     * Is mosaic transferable
     * @returns {boolean}
     */

  }, {
    key: "isTransferable",
    value: function isTransferable() {
      return this.flags.transferable;
    }
    /**
     * Is mosaic restrictable
     * @returns {boolean}
     */

  }, {
    key: "isRestrictable",
    value: function isRestrictable() {
      return this.flags.restrictable;
    }
    /**
     * Generate buffer
     * @return {Uint8Array}
     */

  }, {
    key: "serialize",
    value: function serialize() {
      var mosaicId = this.id.toBuilder();
      var supply = new catbuffer_typescript_1.AmountDto(this.supply.toDTO());
      var startHeight = new catbuffer_typescript_1.HeightDto(this.startHeight.toDTO());
      var ownerAddress = this.ownerAddress.toBuilder();
      var revision = this.revision;
      var duration = new catbuffer_typescript_1.BlockDurationDto(this.duration.toDTO());
      var flags = catbuffer_typescript_1.GeneratorUtils.toFlags(catbuffer_typescript_1.MosaicFlagsDto, this.flags.getValue());
      var properties = new catbuffer_typescript_1.MosaicPropertiesBuilder(flags, this.divisibility, duration);
      var definition = new catbuffer_typescript_1.MosaicDefinitionBuilder(startHeight, ownerAddress, revision, properties);
      return new catbuffer_typescript_1.MosaicEntryBuilder(this.version, mosaicId, supply, definition).serialize();
    }
  }]);

  return MosaicInfo;
}();

exports.MosaicInfo = MosaicInfo;